import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot, Routes } from '@angular/router';
import { JhiResolvePagingParams } from 'ng-jhipster';
import { Observable } from 'rxjs';
import { UserRouteAccessService } from 'src/app/core';
import { BulkDeclarationService, OpenDeclredBulkDeclearationComponent, OpenPendingBulkDeclarationComponent, OpenRejectedBulkDeclarationComponent, PendingBulkDeclarationComponent } from 'src/app/entities/bulk-declaration';
import { Currency, ICurrency } from 'src/app/shared/model/currency.model';
import { RoleUtil } from 'src/app/shared/util/role-util';
import { BulkAutomaticQuotationComponent } from './bulk-automatic-quotation.component';
import { BulkDeclarationRulesCheckedComponent } from './bulk-declaration-rules-checked.component';
import { BulkDeclarationShipmentComponent } from './bulk-declaration-shipment.component';
import { BulkDeclarationSummaryComponent } from './bulk-declaration-summary.component';
import { BulkDeclearationScopesComponent } from './bulk-declearation-scopes.component';
import { BulkNoRulesComponent } from './bulk-no-rules.component';
import { BulkNoScopesComponent } from './bulk-no-scopes.component';
import { DeclredBulkDeclearationComponent } from './declared-bulk-declaration.component';
import { RejectedBulkDeclarationComponent } from './rejected-bulk-declaration.component';

@Injectable({ providedIn: 'root' })
export class BulkDeclarationMySuffixResolve implements Resolve<ICurrency> {
    constructor(private service: BulkDeclarationService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const id = route.params['id'] ? route.params['id'] : null;
        if (id) {
            return this.service.find(id).map((country: HttpResponse<Currency>) => country.body);
        }
        return Observable.of(new Currency());
    }
}
export const bulkDeclarationRoute: Routes = [

    {
        path: 'declare-shipment',
        component: BulkDeclarationShipmentComponent,

        data: {
            authorities: RoleUtil.ClientBrokerUnderwriterInsurerAuthorities,
            // authorities: RoleUtil.ClientAuthorities,
            defaultSort: 'id,asc',
            pageTitle: 'Certificate'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'pending',
        component: PendingBulkDeclarationComponent,
        resolve: {
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER', 'ROLE_ADMIN', 'CLIENT', 'CLIENT_STAFF', 'ADMIN_STAFF', 'BROKER', 'BROKER_STAFF', 'INSURER', 'INSURER_STAFF', 'UNDERWRITER', 'UNDERWRITER_STAFF', 'AUDIT_USER_STAFF', 'AUDIT_USER', 'INSURER_AUDIT', 'UNDERWRITER_AUDIT'],
            defaultSort: 'id,asc',
            pageTitle: 'Certificate'
        },
        canActivate: [UserRouteAccessService]
    },
    
    {
        path: 'open-pending',
        component: OpenPendingBulkDeclarationComponent,
        resolve: {
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER', 'ROLE_ADMIN', 'CLIENT', 'CLIENT_STAFF', 'ADMIN_STAFF', 'BROKER', 'BROKER_STAFF', 'INSURER', 'INSURER_STAFF', 'UNDERWRITER', 'UNDERWRITER_STAFF', 'AUDIT_USER_STAFF', 'AUDIT_USER', 'INSURER_AUDIT', 'UNDERWRITER_AUDIT'],
            defaultSort: 'id,asc',
            pageTitle: 'Certificate'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'declared',
        component: DeclredBulkDeclearationComponent,
        resolve: {
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: ['CLIENT', 'CLIENT_STAFF', 'ROLE_USER', 'ROLE_ADMIN', 'ADMIN_STAFF', 'BROKER', 'BROKER_STAFF', 'INSURER', 'INSURER_STAFF', 'UNDERWRITER', 'UNDERWRITER_STAFF', 'AUDIT_USER_STAFF', 'AUDIT_USER', 'INSURER_AUDIT', 'UNDERWRITER_AUDIT'],
            defaultSort: 'id,asc',
            pageTitle: 'Certificate'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'open-declared',
        component: OpenDeclredBulkDeclearationComponent,
        resolve: {
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: ['CLIENT', 'CLIENT_STAFF', 'ROLE_USER', 'ROLE_ADMIN', 'ADMIN_STAFF', 'BROKER', 'BROKER_STAFF', 'INSURER', 'INSURER_STAFF', 'UNDERWRITER', 'UNDERWRITER_STAFF', 'AUDIT_USER_STAFF', 'AUDIT_USER', 'INSURER_AUDIT', 'UNDERWRITER_AUDIT'],
            defaultSort: 'id,asc',
            pageTitle: 'Certificate'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'rejected',
        component: RejectedBulkDeclarationComponent,
        resolve: {
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: ['CLIENT', 'CLIENT_STAFF', 'ROLE_USER', 'ROLE_ADMIN', 'ADMIN_STAFF', 'BROKER', 'BROKER_STAFF', 'INSURER', 'INSURER_STAFF', 'UNDERWRITER', 'UNDERWRITER_STAFF', 'AUDIT_USER_STAFF', 'AUDIT_USER', 'INSURER_AUDIT', 'UNDERWRITER_AUDIT'],
            defaultSort: 'id,asc',
            pageTitle: 'Certificate'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'open-rejected',
        component: OpenRejectedBulkDeclarationComponent,
        resolve: {
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: ['CLIENT', 'CLIENT_STAFF', 'ROLE_USER', 'ROLE_ADMIN', 'ADMIN_STAFF', 'BROKER', 'BROKER_STAFF', 'INSURER', 'INSURER_STAFF', 'UNDERWRITER', 'UNDERWRITER_STAFF', 'AUDIT_USER_STAFF', 'AUDIT_USER', 'INSURER_AUDIT', 'UNDERWRITER_AUDIT'],
            defaultSort: 'id,asc',
            pageTitle: 'Certificate'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'scopes',
        component: BulkDeclearationScopesComponent,

        data: {
            authorities: ['CLIENT', 'CLIENT_STAFF', 'ROLE_USER', 'ROLE_ADMIN', 'ADMIN_STAFF', 'BROKER', 'BROKER_STAFF', 'INSURER', 'INSURER_STAFF', 'UNDERWRITER', 'UNDERWRITER_STAFF'],
            defaultSort: 'id,asc',
            pageTitle: 'Scopes'
        },
        canActivate: [UserRouteAccessService]
    },

    {
        path: 'summary-Details/:certificateRequestId/:scopeId/:isCertificatedDownloaded/:isOpenRequest',
        component: BulkDeclarationSummaryComponent,
        data: {
            authorities: [
                'CLIENT',
                'CLIENT_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF',
                'AUDIT_USER',
                'AUDIT_USER_STAFF',
                'INSURER_AUDIT', 
                'UNDERWRITER_AUDIT'
            ],
            pageTitle: 'Certificate'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'summary-Details/:certificateRequestId/:scopeId/:isCertificatedDownloaded',
        component: BulkDeclarationSummaryComponent,
        data: {
            authorities: [
                'CLIENT',
                'CLIENT_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF',
                'AUDIT_USER',
                'AUDIT_USER_STAFF',
                'INSURER_AUDIT', 
                'UNDERWRITER_AUDIT'
            ],
            pageTitle: 'Certificate'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'rules-check/:certificateRequestId',
        component: BulkDeclarationRulesCheckedComponent,
        resolve: {
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: [
                'BROKER',
                'BROKER_STAFF',
                'CLIENT',
                'CLIENT_STAFF',
                'AUDIT_USER_STAFF',
                'AUDIT_USER',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF',
                'INSURER_AUDIT',
                'UNDERWRITER_AUDIT'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'Manual Request'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'open-rules-check/:certificateRequestId',
        component: BulkDeclarationRulesCheckedComponent,
        resolve: {
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: [
                'BROKER',
                'BROKER_STAFF',
                'CLIENT',
                'CLIENT_STAFF',
                'AUDIT_USER_STAFF',
                'AUDIT_USER',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF',
                'INSURER_AUDIT',
                'UNDERWRITER_AUDIT'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'Manual Request'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'no-scope',
        component: BulkNoScopesComponent,

        data: {
            authorities: RoleUtil.ClientBrokerUnderwriterInsurerAuthorities,
            defaultSort: 'id,asc',
            pageTitle: 'Certificate'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'no-rules',
        component: BulkNoRulesComponent,

        data: {
            authorities: RoleUtil.ClientBrokerUnderwriterInsurerAuthorities,
            defaultSort: 'id,asc',
            pageTitle: 'Certificate'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'automatic-aprrovel',
        component: BulkAutomaticQuotationComponent,

        data: {
            authorities: RoleUtil.ClientAuthorities,
            defaultSort: 'id,asc',
            pageTitle: 'Certificate'
        },
        canActivate: [UserRouteAccessService]
    },


];
